module.exports = __webpack_public_path__ + "img/3f_r_tokyocafe@2x.e148e38a.png";